import {
  GetTaskConfigurationSendDocumentTemplatesDocument,
  type GetTaskConfigurationSendDocumentTemplatesQuery
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type TaskConfigurationSendDocumentTemplate =
  GetTaskConfigurationSendDocumentTemplatesQuery['processes']['taskConfigurationSendDocumentTemplatesConnection']['nodes'][number]

export const useTaskConfigurationSendDocumentTemplate = (documentTemplateIds?: string[] | null) => {
  const skip = !documentTemplateIds || documentTemplateIds.length === 0
  const variables = { documentTemplateIds: documentTemplateIds }

  const { data, loading } = useQuery(GetTaskConfigurationSendDocumentTemplatesDocument, {
    variables,
    skip
  })

  return {
    loading,
    taskConfigurations: data?.processes.taskConfigurationSendDocumentTemplatesConnection.nodes ?? []
  }
}
